import { Type } from "class-transformer";
import { DateIntv } from "./DateIntv";

export class SimLogSearchOptions {
    @Type(() => DateIntv)
    dateIntvs: DateIntv[];
    handlerNamePattern: string;
    query: string;
    conversion: string;
    returnFullLog = false;
}
